/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  SubProductType,
  Url,
  UUID,
} from '@hc-frontend/core-types';
import { z } from 'zod';

/**
 * Parameters for persisting consent tokens onto the Lead Storage prospect.
 *
 * `leadId` (the Jornaya LeadiD, persisted downstream as `tcpaUniversalId`) and
 * `trustedFormUrl` (the TrustedForm certificate URL) are both optional, but the
 * `.refine()` requires at least one — a prospect update with neither token
 * carries no consent and must never be persisted. This shape supports the
 * MP-3689 Jornaya-failure fallback where only the TrustedForm cert is available;
 * the downstream Lead Storage DTO already accepts a cert-only update.
 */
export const UpdateProspectLeadIdParameters = z
  .object({
    userId: HealthcareUserId,
    sessionId: HealthcareSessionId,
    domainUserId: DomainUserId.optional(),
    domainSessionId: DomainSessionId.optional(),
    leadId: UUID.optional(),
    subProductType: SubProductType.optional(),
    trustedFormUrl: Url.optional(),
  })
  .refine((data) => Boolean(data.leadId) || Boolean(data.trustedFormUrl), {
    message: 'At least one of leadId or trustedFormUrl is required',
    path: ['leadId'],
  });

export type UpdateProspectLeadIdParameters = z.infer<
  typeof UpdateProspectLeadIdParameters
>;
